import { render, staticRenderFns } from "./TaskLink.vue?vue&type=template&id=35c62d57&"
import script from "./TaskLink.vue?vue&type=script&lang=js&"
export * from "./TaskLink.vue?vue&type=script&lang=js&"
import style0 from "./TaskLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
